import { apiClient } from './config';

export const getSubscriptions = async () => {
  const { data } = await apiClient.get('common/info/subscription-types/all');
  return data;
};
